import {useUnit} from 'effector-react';
import React, {FC} from 'react';

import {ConfigsLoadingError} from '#components2/support/common/components/warnings';
import Forms from 'components/App/components/Content';
import {useRefreshAuth} from 'hooks/useRefreshAuth';
import {useSetupForm} from 'hooks/useSetup';
import {$configsError} from 'models';
import 'amber-blocks/stylus/clear.styl';
import 'amber-blocks/font/font.styl';

const App: FC = () => {
    const {isReady} = useSetupForm();
    const configsError = useUnit($configsError);
    useRefreshAuth(window.serverData.passportHost);

    if (configsError && !isReady) {
        return <ConfigsLoadingError/>;
    }

    if (!isReady) {
        return null;
    }

    return (
        <Forms/>
    );
};

export default App;
